import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { AuthLifecycleService } from './core/auth/services/auth-lifecycle.service';
import { InstanceActiveListener } from './core/listeners/instance-active.listener';
import { InstanceActiveService } from './core/services/instance-active.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'Icosaedro';

    constructor(
        private instanceActiveService: InstanceActiveService,
        private authLifecycle: AuthLifecycleService,
        private instanceActiveListener: InstanceActiveListener // NO BORRAR, NECESARIO PARA QUE CARGUE EL InstanceActiveListener al lanzar la aplicación
    ) {}

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(_event: Event): void {
        this.instanceActiveService.persistCurrentSelection();
    }

    @HostListener('document:visibilitychange')
    onVisibilityChange(): void {
        this.authLifecycle.onVisibilityChange();
    }

    ngOnInit(): void {
        this.instanceActiveService.loadCurrentSelectionFromStorage();
        this.instanceActiveService.loadInstanceFromStorage();
        this.authLifecycle.initialize();
    }

    ngOnDestroy(): void {
        this.authLifecycle.ngOnDestroy();
    }
}
